module.exports = __webpack_public_path__ + "static/media/reference.0b7b11f9.svg";